import React from 'react';
import icon from '../../images/icons/ellipsis-horizontal.svg';

const EllipsisHorizontal = ({ className = '' }: { className: string }) => (
  <img src={icon} className={className} alt="" />
);

export default EllipsisHorizontal;
